// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"52ccfae0","269":"05e2a968","272":"5d9edfe7","488":"a9e67327","551":"dbe52f54","704":"04d4638f","994":"9722ba6b"}[chunkId] + ".chunk.js";
};